import { useSelector } from 'react-redux'

import { Loading } from '~/components'

import Styled from './dashboard-berthing-management.styled'
import useHooks from './dashboard-berthing-management.hooks'
import { BerthingInfo, BerthingActivity, BerthingPagination } from './components'

import DashboardEmpty from '../dashboard-empty'
import { DropdownLocSide } from '../dashboard-dropdown.container'

const DashboardBerthingManagement = () => {
  const { data, methods } = useHooks()

  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  return (
    <Styled.Main>
      <Styled.Section>
        <Styled.SectionTitle>Dashboard Berthing Management</Styled.SectionTitle>

        <Styled.DropdownContainer>
          <DropdownLocSide
            location={Location}
            dataList={UserLocations}
            setLocation={methods.handleSetLocation}
          />
        </Styled.DropdownContainer>
      </Styled.Section>

      {data.isLoading && (
        <Styled.Main height={data.appHeight}>
          <Loading />
        </Styled.Main>
      )}

      {!data.isLoading && data.dataBerthing.length === 0 && (
        <DashboardEmpty title='There are no vessel activities at the moment.' />
      )}

      {!data.isLoading && data.dataBerthing.length > 0 && (
        <>
          <Styled.CardContainer gridTemplateColumns={methods.mapGridTemplateColumns(data.dataBerthing.length)}>
            {data.dataBerthing.map((berthing, berthingIndex) => (
              <Styled.Card
                key={berthingIndex}
                size={data.dataBerthing.length}
                width={data.dataBerthing.length > 1 ? '100%' : '750px'}
                height={data.dataBerthing.length > 3 ? '38vh' : '76vh'}
              >
                <BerthingInfo berthing={berthing} data={data} />

                <Styled.CardContentWrapper>
                  <Styled.CardContentTitle fontSize={data.dataBerthing.length === 3 ? '14px' : '16px'}>
                    Compliance Parameter Status
                  </Styled.CardContentTitle>
                  <Styled.ActivityListContainer>
                  {berthing.activity.map((activity, activityIndex) => (
                    <BerthingActivity
                      key={activityIndex}
                      activity={activity}
                      layout={data.dataBerthing.length}
                      handleToggleExpand={methods.handleToggleExpand}
                    />
                  ))}
                  </Styled.ActivityListContainer>
                </Styled.CardContentWrapper>
              </Styled.Card>
            ))}
          </Styled.CardContainer>

          <BerthingPagination data={data} methods={methods} />
        </>
      )}
    </Styled.Main>
  )
}

export default DashboardBerthingManagement

DashboardBerthingManagement.propTypes = {}